/* eslint-disable prettier/prettier */
import "./bubble.css";

export default {
  bind(el, binding) {
    const obj = Object.assign({
      size: 10,
      color: "#326FEF",
      bgColor: "#15CDD4"
    },
    binding.value
    );
    setTimeout(() => {

      if (
        !window.getComputedStyle(el, null).position ||
                window.getComputedStyle(el, null).position == "static" ||
                window.getComputedStyle(el, null).position == "initial"
      ) {
        el.style.position = "relative";
      }

      el.style.cursor = "none";

      // oBubbles
      var oBubbles = document.createElement("div");
      oBubbles.className = "bubbles";
      oBubbles.style.width = (obj.size) + "px";
      oBubbles.style.height = (obj.size) + "px";
      oBubbles.style.background = obj.bgColor;
      oBubbles.style.boxShadow = "0 0 5px #15CDD4";

      // add-warning
      el.addEventListener("mousemove", (e) => {
        if (e.target.className == "bubbles") {
          return;
        }
        var oBubble = document.createElement("div");
        oBubble.className = "bubble";
        oBubble.style.width = (obj.size) + "px";
        oBubble.style.height = (obj.size) + "px";
        oBubble.style.left = e.clientX - el.getBoundingClientRect().left - obj.size / 2 + "px";
        oBubble.style.top = e.clientY - el.getBoundingClientRect().top - obj.size / 2 + "px";
        // oBubble.style.borderColor = obj.color;
        oBubble.style.background = obj.bgColor;
        oBubble.style.boxShadow = "0 0 5px #15CDD4";


        //oBubbles
        oBubbles.style.left = e.clientX - el.getBoundingClientRect().left - obj.size / 2 + "px";
        oBubbles.style.top = e.clientY - el.getBoundingClientRect().top - obj.size / 2 + "px";


        el.appendChild(oBubble);
        el.appendChild(oBubbles);
        // let i = 0,
        //     timer = setInterval(function () {
        //         i -= 1.5;
        //         oBubble.style.opacity = (50 - i) / 50;
        //         oBubble.style.width = (obj.size + i) + "px";
        //         oBubble.style.height = (obj.size + i) + "px";
        //         oBubble.style.left = e.clientX - el.getBoundingClientRect().left - (obj.size + i) / 2 + "px";
        //         oBubble.style.top = e.clientY - el.getBoundingClientRect().top - (obj.size + i) / 2 + "px";
        //     }, 30)
        setTimeout(() => {
          // clearInterval(timer);
          el.removeChild(oBubble);
        }, 300)
      })

    })

  }
};